
import { createTranslator, type useTranslations } from "next-intl"
import englishMessages from "@/translations/en/pbx-templates.json"

const englishTranslator = createTranslator({ locale: "en", messages: englishMessages, namespace: "PbxTemplates" })
export type FlowTemplate =
  | 'operator_first'
  | 'ai_first'
  | 'business_hours'
  | 'ai_only'
  | 'voicemail_only'
  | 'custom'

export interface TemplateInfo {
  id: FlowTemplate
  name: string
  description: string
  icon: 'users-phone' | 'bot-phone' | 'clock' | 'bot' | 'voicemail' | 'settings'
}

export interface WizardState {
  step: number
  template: FlowTemplate | null
  name: string
  phoneNumber: string | null
  phoneSelectionKey?: string | null

  // Operator settings
  operatorGroupId?: string
  operatorPhoneNumbers?: string[]
  operatorPhoneNumbersRaw?: string // Raw textarea value to preserve newlines
  operatorTimeout?: number
  operatorTimeoutRaw?: string // Raw input value for editing
  operatorSimulring?: boolean
  operatorRecordCall?: boolean

  // AI Agent settings
  voiceAgentId?: string
  voiceAgentExternalId?: string // External provider agent ID
  humanHandoverEnabled?: boolean
  sipInboundRoutingAcknowledged?: boolean

  // Time check settings
  timezone?: string
  workingDays?: string[]
  workingHoursStart?: string
  workingHoursEnd?: string

  // Voicemail settings
  voicemailGreeting?: string
  voicemailMaxDuration?: number
  voicemailTranscribe?: boolean
}

export const TEMPLATES = getTEMPLATES()

export function getTEMPLATES(t: ReturnType<typeof useTranslations<"PbxTemplates">> = englishTranslator): TemplateInfo[] {
  return [
  {
    id: 'operator_first',
    name: t("operatorFirst"),
    description: t("callsGoToOperatorsFirstIfNoAnswer"),
    icon: 'users-phone',
  },
  {
    id: 'ai_first',
    name: t("aIFirst"),
    description: t("aIAgentHandlesCallsCanTransferToOperators"),
    icon: 'bot-phone',
  },
  {
    id: 'business_hours',
    name: t("businessHours"),
    description: t("routeCallsDifferentlyBasedOnWorkingHours"),
    icon: 'clock',
  },
  {
    id: 'ai_only',
    name: t("aIOnly"),
    description: t("aIAgentHandlesAllCallsWithoutOperatorBackup"),
    icon: 'bot',
  },
  {
    id: 'voicemail_only',
    name: t("voicemailOnly"),
    description: t("simpleVoicemailPlayAMessageAndRecord"),
    icon: 'voicemail',
  },
  {
    id: 'custom',
    name: t("custom"),
    description: t("buildFromScratchInTheAdvancedFlowEditor"),
    icon: 'settings',
  },
]
}

export const DEFAULT_WIZARD_STATE: WizardState = {
  step: 0,
  template: null,
  name: '',
  phoneNumber: null,
  phoneSelectionKey: null,
  operatorTimeout: 30,
  operatorSimulring: true,
  operatorRecordCall: false,
  humanHandoverEnabled: true,
  timezone: 'Europe/Kyiv',
  workingDays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
  workingHoursStart: '09:00',
  workingHoursEnd: '18:00',
  voicemailMaxDuration: 120,
  voicemailTranscribe: true,
}
